

export const warning = {
    msg: `Reactivar sonido de alertas`,
    color: '#EB963C',
    icon: 'caution',
    backgroundColor: '#FFFCE5',
    borderColor: '#EB963C'
};

export const success = {
    msg: `Nuevos pedidos express ingresados`,
    color: '#22A889',
    icon: 'bell',
    backgroundColor: '#E6F5F1',
    borderColor: '#B6DFD6'
};
